import { handleGetRequest } from "./http.service";

export interface InspectionMynda {
  _id: string;
  occupation?: string[];
  state?: string;
  lga?: string;
  user?: { firstName: string; lastName: string; phoneNumber: string };
}

export interface InspectionAgency {
  _id: string;
  name?: string;
  companyEmail?: string;
  phoneNumber?: string;
}

export interface Inspection {
  _id: string;
  message?: string;
  dateTime?: string;
  mynda: InspectionMynda;
  agency: InspectionAgency;
  createdAt: string;
}

export interface InspectionsResponse {
  page: number;
  limit: number;
  total: number;
  data: Inspection[];
}

export const getAllInspections = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<InspectionsResponse>(`/inspections${query}`);
};
